import { Helper, WindowElement } from '../../../../../../classes/helper'
import { cover } from '../../../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../../../context/montage.context'

interface Props {
  isGlass: boolean
  isSlanted: boolean
}

export const WindowsSideTie = ({ isGlass, isSlanted }: Props) => {
  const { measure, roof } = useMontage()
  const { height, deltaY } = WindowElement.shapePositions(measure)

  const heightPosition = measure.userHeight - (height + deltaY)
  const iterations = isSlanted ? 1 : 2

  return (
    <>
      {[...Array(iterations)].map((_, index) => {
        return (
          <mesh
            key={index}
            castShadow={cover.terraceCover.castShadow}
            position={[
              Helper.convertToMeter(
                measure.userWidth / 2 - cover.bar.height / 2
              ),
              Helper.convertToMeter(index ? heightPosition : isGlass ? 1.7 : 0),
              Helper.convertToMeter(measure.userDepth / 2),
            ]}
            rotation={[
              Helper.convertAngleToRadiant(0),
              Helper.convertAngleToRadiant(90),
              Helper.convertAngleToRadiant(0),
            ]}
          >
            <boxGeometry
              args={[
                Helper.convertToMeter(measure.userDepth),
                Helper.convertToMeter(cover.terraceCover.glassTie),
                Helper.convertToMeter(cover.terraceCover.glassTie),
              ]}
            />
            <meshPhysicalMaterial
              color={roof.userColor}
              transparent
              visible={index ? true : isGlass}
            />
          </mesh>
        )
      })}
    </>
  )
}
